<script setup lang="ts">
import PlaceHolder from '@/components/PlaceHolder/PlaceHolder.vue';
</script>

<template>
  <div :class="$style.placeHolderWrapper">
    <div :class="$style['part-1']">
      <div :class="$style.logo">
        <PlaceHolder />
      </div>
      <div :class="$style.basicInfo">
        <div v-for="n in [1, 2]" :key="`basicInfo-${n}`" :class="$style.basicInfoItem">
          <PlaceHolder />
        </div>
      </div>
      <div :class="$style.propertiesCount">
        <div v-for="item in [1, 2]" :key="item" :class="$style.propertiesCountItem">
          <PlaceHolder />
          <PlaceHolder />
        </div>
      </div>
    </div>
    <div :class="$style['part-2']">
      <PlaceHolder />
    </div>
    <div :class="$style['part-3']">
      <PlaceHolder />
    </div>
  </div>
</template>

<style module lang="scss">
@use '@/assets/variables' as *;

.placeHolderWrapper {
  display: flex;
  flex-direction: column;
  gap: $space-200;
  padding: $space-200;
  border: 1px solid $color-grey-50;
  border-radius: $border-radius-l;
}

.part-1 {
  position: relative;

  --columns-per-row: 1;

  display: grid;
  grid-template-columns: repeat(var(--columns-per-row), auto);
  gap: $space-100;
  justify-content: flex-start;

  @media (min-width: $viewport-sm-min) {
    grid-template-columns: $space-1000 1fr;
    gap: $space-150;
    justify-content: space-evenly;

    --columns-per-row: 2;
  }

  @media (min-width: $viewport-md-min) {
    grid-template-columns: $space-1000 1fr auto;

    --columns-per-row: 3;
  }

  .logo {
    width: $space-1000;
    height: $space-600 * 1.04;
  }

  .basicInfo {
    display: flex;
    flex-direction: column;
    gap: $space-50;
    justify-content: center;

    .basicInfoItem {
      width: $space-250 * 5;
      height: $space-200;
    }
  }

  .propertiesCount {
    display: flex;
    gap: $space-150;

    .propertiesCountItem {
      display: flex;
      flex-direction: column;
      gap: $space-50;
      justify-content: center;

      div:first-child {
        width: $space-200;
        height: $space-200;
      }

      div:last-child {
        width: $space-800;
        height: $space-200;
      }
    }
  }
}

.part-2 {
  position: relative;
  height: $space-300;

  @media (min-width: $viewport-sm-min) {
    height: $space-600;
  }

  @media (min-width: $viewport-md-min) {
    height: $space-700;
  }
}

.part-3 {
  width: $space-400;
  height: $space-400;

  > div {
    border-radius: 100%;
  }
}
</style>
